import React from "react";
import { TID } from "@/constants/testIds";
import { COPY, TICKER_PAIRS } from "@/copy";

export const Hero = () => {
  const scrollToDecoder = () => {
    document.getElementById("decoder")?.scrollIntoView({ behavior: "smooth" });
  };

  // Duplicate for seamless loop
  const tickerList = [...TICKER_PAIRS, ...TICKER_PAIRS];

  return (
    <section
      id="top"
      data-testid={TID.heroSection}
      className="relative ds-border border-l-0 border-r-0 border-t-0 bg-ds-bone overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-24 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <div className="ds-mono text-xs uppercase tracking-[0.3em] mb-6 inline-block ds-border px-3 py-1 bg-ds-yellow">
            {COPY.hero_kicker}
          </div>
          <h1
            data-testid={TID.heroTitle}
            className="ds-display text-5xl sm:text-6xl lg:text-7xl xl:text-8xl"
          >
            {COPY.hero_title_1}
            <br />
            <span className="text-ds-flame">{COPY.hero_title_2}</span>
          </h1>
          <p className="mt-8 max-w-xl text-base md:text-lg leading-relaxed text-ds-ink/80">
            {COPY.hero_sub}
          </p>
          <div className="mt-10 flex flex-wrap gap-4 items-center">
            <button
              data-testid={TID.heroCta}
              onClick={scrollToDecoder}
              className="ds-border bg-ds-flame text-ds-ink px-7 py-3.5 ds-mono uppercase tracking-widest text-sm font-bold ds-shadow hover:ds-shadow-lg hover:-translate-x-0.5 hover:-translate-y-0.5 transition-all"
            >
              {COPY.hero_cta} →
            </button>
            <div className="ds-mono text-xs uppercase tracking-widest text-ds-ink/60">
              built for indian dating context
            </div>
          </div>
        </div>

        {/* TICKER PANEL */}
        <div className="lg:col-span-5">
          <div
            data-testid={TID.heroTicker}
            className="ds-border ds-shadow-lg bg-ds-oxblood overflow-hidden relative"
          >
            {/* Header row */}
            <div className="grid grid-cols-2 ds-border border-t-0 border-l-0 border-r-0 bg-ds-ink text-ds-bone">
              <div className="px-4 py-2 ds-mono text-[10px] uppercase tracking-[0.3em] border-r-2 border-ds-bone/20">
                {COPY.hero_ticker_say}
              </div>
              <div className="px-4 py-2 ds-mono text-[10px] uppercase tracking-[0.3em] text-ds-flame">
                {COPY.hero_ticker_mean}
              </div>
            </div>

            {/* Scrolling list */}
            <div className="h-[440px] overflow-hidden relative">
              <div className="animate-ticker-up">
                {tickerList.map((pair, i) => (
                  <div
                    key={i}
                    className="grid grid-cols-2 border-b border-ds-bone/15"
                  >
                    <div className="px-4 py-4 border-r border-ds-bone/15 flex items-center">
                      <span className="text-ds-bone/85 text-base md:text-lg ds-display-medium">
                        &quot;{pair[0]}&quot;
                      </span>
                    </div>
                    <div className="px-4 py-4 flex items-center">
                      <span className="text-ds-flame text-sm md:text-base leading-snug font-medium">
                        {pair[1]}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
              {/* Gradient fades top/bottom */}
              <div className="pointer-events-none absolute top-0 left-0 right-0 h-12 bg-gradient-to-b from-ds-oxblood to-transparent" />
              <div className="pointer-events-none absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-ds-oxblood to-transparent" />
            </div>

            {/* Footer label */}
            <div className="ds-border border-b-0 border-l-0 border-r-0 bg-ds-ink text-ds-bone/60 px-4 py-2 ds-mono text-[10px] uppercase tracking-[0.3em] flex items-center justify-between">
              <span className="text-ds-flame animate-flicker">● LIVE</span>
              <span>the subtitle reel</span>
            </div>
          </div>
        </div>
      </div>

      {/* Marquee strip */}
      <div className="ds-border border-l-0 border-r-0 bg-ds-ink text-ds-bone py-3 overflow-hidden whitespace-nowrap">
        <div className="ds-marquee inline-block ds-mono text-xs uppercase tracking-[0.4em]">
          {Array(8).fill('NO DIPLOMACY · NO HEDGING · NO THERAPY-SPEAK · JUST THE TRUTH · ').join(" ")}
        </div>
      </div>
    </section>
  );
};
